import FuseSettingsConfig from './fuseSettingsConfig';
import * as _ from 'lodash';
var defaultSettings = {
    layout: {
        style: 'layout1',
        config: {
            scroll: 'content',
            navbar: {
                display: true,
                folded: false,
                position: 'left',
            },
            toolbar: {
                display: true,
                style: 'fixed',
                position: 'below',
            },
            footer: {
                display: true,
                style: 'fixed',
                position: 'below',
            },
            mode: 'fullwidth',
        },
    },
    customScrollbars: true,
    theme: {
        main: 'default',
        navbar: 'mainThemeDark',
        toolbar: 'mainThemeLight',
        footer: 'mainThemeDark',
    },
};
var FuseDefaultSettings = _.merge({}, defaultSettings, FuseSettingsConfig);
export default FuseDefaultSettings;



//////////////////
// WEBPACK FOOTER
// ./src/fuse-configs/fuseDefaultSettings.ts
// module id = 1167
// module chunks = 81